module.exports = __webpack_public_path__ + "static/media/spinner.7c13437f.svg";